import React from 'react';
import banImg from "../../assets/images/career/banner.webp";
// import banVid from "../../assets/images/career/career-vid.mp4";
import { Link } from 'react-router-dom';
function BannerCareer() {
  return (
    <section className='banner-career'>
        <img src={banImg} className="ban-img"/>
        {/* <video src={banVid} autoPlay loop muted className='ban-img' /> */}
        <div className='banner-caption-sec'>
            <div className='container'>
                <div className='caption-banner'>
                    <div className='ban-caption'>
                        <h1 className='big-ttl'>Join Our <br/> Innovative Team</h1>
                        <p className='sm-para'>Explore exciting opportunities to be a part of Choice Techlab. We're on the lookout for passionate individuals who want to shape the future through innovation and creativity.</p>
                        <Link to='/job-application' className='btn white-btn'><span>View Career Opportunities</span></Link>
                    </div>
                </div>
            </div>
        </div>
    </section>
  )
}

export default BannerCareer;
